<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 위험물시설 -->
    <write-grid-container title="위험물시설" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{form.subInfo[value]}}</div>
          <div class="print-input" v-else>{{form.subInfo[value]}}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <custom-option-selector v-else-if="dataType === 'selector1'" class="w-full" v-model="form.subInfo[value]" :options="result_options1" />
          <custom-option-selector v-else-if="dataType === 'selector2'" class="w-full" v-model="form.subInfo[value]" :options="result_options2" />
          <ml-input v-else-if="dataType === 'number'" class="w-full" type="number" v-model="form.subInfo[value]" :min-value="0" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <file-download-post class="mt-8" title="파일첨부" v-model="form.fileList"/>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";

export default {
  components: {
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      result_options1: ["고압가스", "액화석유가스", "도시가스"],
      result_options2: ["제조", "취급", "저장"],
      gridContainerOptions: {
        dataTypes: ["string", "selector1", "selector2", "string", "string", "number", "date"],
        labels: ["공장명", "구분1", "구분2", "시설명", "설치위치", "저장/취급수량", "인허가일"],
        values: ["공장명", "구분1", "구분2", "시설명", "설치위치", "저장_취급수량", "인허가일"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = '';
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
